import Vue from 'vue';
import { trimHttp, biliNumFormat } from '../utils/index';
import {formatDuration} from '../utils/time';

function formatNum(n) {
    return n < 10 ? '0' + n : n;
}

Vue.filter('formatDuration', (n) => {
    return formatDuration(n);
});

Vue.filter('formatDate', (t) => {
    if (!t) return;
    let date = new Date(t);
    let Y = date.getFullYear() + '-';
    let M = formatNum(date.getMonth() + 1) + '-';
    let D = formatNum(date.getDate());
    return Y + M + D;
});

Vue.filter('formatDateTime', function (t) {
    if (!t) return;
    let date = new Date(t);
    let Y = date.getFullYear() + '-';
    let M = formatNum(date.getMonth() + 1) + '-';
    let D = formatNum(date.getDate());
    let h = formatNum(date.getHours()) + ':';
    let m = formatNum(date.getMinutes()) + ':';
    let s = formatNum(date.getSeconds());
    return Y + M + D + ' ' + h + m + s;
});

// 数字单位处理
Vue.filter('formatNum', (n) => {
    return biliNumFormat(n);
});

// 去http协议
Vue.filter('trimHttp', (url) => {
    return trimHttp(url);
});

// 播放量大于万显示 XXX万
Vue.filter('isThousand', (value) => {
    if (!value) return '';
    const numVal = Number(value);
    return numVal > 10000 ? (numVal / 10000).toFixed(1) + '万' : value;
});
